import OidcClient from '@edirect/oidc-client';
import {
  OidcClientOptionsType,
  OidcClientType,
  OidcServiceInterface,
} from '../auth';
import { configService } from '../../../modules/config/services/config.service';
import { loggerService } from '../logger';

const retries = 5;

export class OidcService implements OidcServiceInterface {
  private serverClient: OidcClientType | null = null;
  private userClient: OidcClientType | null = null;
  private userRetries = 0;
  private serverRetries = 0;

  public async createClient(
    clientOptions: OidcClientOptionsType,
  ): Promise<OidcClientType> {
    return OidcClient({
      baseUrl:
        process.env.AUTH_SERVICE_URL || configService.get('AUTH_SERVICE_URL'),
      oidcPath:
        process.env.AUTH_SERVICE_OIDC_PATH ||
        configService.get('AUTH_SERVICE_OIDC_PATH'),
      clientId:
        process.env.AUTH_SERVICE_CLIENT_ID ||
        configService.get('AUTH_SERVICE_CLIENT_ID'),
      clientSecret:
        process.env.AUTH_SERVICE_CLIENT_SECRET ||
        configService.get('AUTH_SERVICE_CLIENT_SECRET'),
      ...clientOptions,
    }) as unknown as OidcClientType;
  }

  public async getServerClient(): Promise<OidcClientType> {
    try {
      if (!this.serverClient) {
        loggerService.debug('[serverClient] Connecting to auth-service...');

        this.serverClient = await this.createClient({
          grantType: 'client_credentials',
        });

        loggerService.debug(
          '[serverClient] Successfully connection to auth-service.',
        );
      }

      return this.serverClient;
    } catch (error) {
      loggerService.error(
        '[serverClient] Error connecting to auth-service: ',
        error,
      );

      if (!this.serverRetries) {
        this.serverRetries = 0;
      }

      this.serverRetries++;

      if (this.serverRetries === retries) {
        loggerService.error(
          '[serverClient] Limit number of attempts reached',
          error,
        );
      }

      return this.getUserClient();
    }
  }

  public async getUserClient(): Promise<OidcClientType> {
    try {
      if (!this.userClient) {
        loggerService.debug('[userClient] Connecting to auth-service...');

        this.userClient = await this.createClient({
          grantType: 'client_credentials',
        });

        loggerService.debug(
          '[userClient] Successfully connection to auth-service.',
        );
      }

      return this.userClient;
    } catch (error) {
      loggerService.error(
        '[userClient] Error connecting to auth-service: ',
        error,
      );

      if (!this.userRetries) {
        this.userRetries = 0;
      }

      this.userRetries++;

      if (this.userRetries === retries) {
        loggerService.error(
          '[userClient] Limit number of attempts reached',
          error,
        );
      }

      return this.getUserClient();
    }
  }
}

export const oidcService = new OidcService();
